import { render, staticRenderFns } from "./BizDetail.vue?vue&type=template&id=31f0dcf6&scoped=true&"
import script from "./BizDetail.vue?vue&type=script&lang=js&"
export * from "./BizDetail.vue?vue&type=script&lang=js&"
import style0 from "./BizDetail.vue?vue&type=style&index=0&id=31f0dcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f0dcf6",
  null
  
)

export default component.exports